import { useCallback } from 'react'
import useGlobalSearchURLHashVertical from 'hooks/GlobalSearch/useGlobalSearchURLHashVertical'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import { rem } from 'polished'
import { useIntl } from 'react-intl'

const SearchBar = styled(TextButton)`
  width: 100%;
  justify-content: start;
  padding: ${rem(6)} ${rem(18)};
  margin-top: ${rem(16)};
  box-shadow: ${props => props.theme.shadow.flat.small};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
`

function CarsAirportTransferMobileSearchBar() {
  const { toggleSearchVertical } = useGlobalSearchURLHashVertical()

  const intl = useIntl()

  const openSearch = useCallback(() => {
    toggleSearchVertical('cars')
  }, [toggleSearchVertical])

  return <SearchBar kind="primary" variant="dark" size="medium" onClick={openSearch}>
    {intl.formatMessage({
      id: '1P3FwiUlrDUEKa5OD22A',
      defaultMessage: 'Search cars',
      description: 'Placeholder text for cars page search bar on mobile',
    })}
  </SearchBar>
}

export default CarsAirportTransferMobileSearchBar
